import { ActiveMeetingBroadcast, ScreenshareDetails, StageInvitationBasicInfo } from 'domain/Broadcast';
import { Timestamp } from 'domain/Common';
import { EventMetricsPayload, EventRoom, EventRoomAttendee, MeetingGuest } from 'domain/event';

import type { QuestionAssignmentWSPayload } from 'question/state/types';

export enum EventPhase {
  WaitingRoom = 'WAITING_ROOM',
  Broadcast = 'BROADCAST',
  Nattering = 'NATTERING',
  Ended = 'ENDED',
}

export enum NatteringPhase {
  WaitingToStart = 'WAITING_TO_START',
  InProgress = 'IN_PROGRESS',
}

export enum NatteringStatus {
  Initial = 'INITIAL',
  ToBeDecided = 'TO_BE_DECIDED',
  Accepted = 'ACCEPTED',
  Skipped = 'SKIPPED',
}

export interface ActiveRoomState {
  id: string;
  isBroadcastCountdown: boolean;
  joinedAsSupport: boolean;
  showTranscriptionModal: boolean;
  isTranscribing: boolean;
}

export type AudienceCountUpdatedPayload = {
  audienceCount: number;
};

export interface EventState {
  activeEventId?: number;
  broadcast: ActiveMeetingBroadcast | null;
  audience: MeetingGuest[];
  audienceCount: number;
  speakers: MeetingGuest[];
  serverTimeOffset: number;
  activeRoom: ActiveRoomState | null;
  rooms: EventRoom[];
  displayRoomHelpCenter: boolean;
  roomsRequestingSupport: string[];
  roomsCount: number;
  pin: string;
  screensharingDetails: ScreenshareDetails | null;
  isScreensharing: boolean;
  metrics: EventMetricsPayload;
  stageInvitation: StageInvitationBasicInfo | null;
  lastCallGuests: EventRoomAttendee[];
  isJoiningNattering: boolean;
  natteringRoundStartTime: Timestamp | undefined;
  natteringRoundEndTime: Timestamp | undefined;
  natteringRoundTopic: string | undefined;
  isBigMeetingMode: boolean;
  participantsInvitedToStage: number[];
  participantsWithRaisedHands: number[];
  participantsDisconnected: number[];
  showAudienceList: boolean;
  activePanelTab: number;
  isWaitingForNattering: boolean;
  /** Skipped Nattering insights */
  questionsAssignments: QuestionAssignmentWSPayload[];
  activeSpeakersIds: number[];
  roomIdToRate: string | null;
  eventPhase: EventPhase;
  natteringPhase: NatteringPhase;
  natteringStatus: NatteringStatus;
  rematchCountdown: { endsAt: number } | null;
  /**
   * When set, a `broadcastStarted_WS` arrived while the participant was still in the just-in-time
   * matching teleprompter (never matched). We buffer the broadcast mount for this countdown so the
   * teleprompter can play "Broadcast has resumed → returning in 3,2,1" before the broadcast appears.
   */
  natteringResumeCountdown: { endsAt: number } | null;
  /**
   * While true, the just-in-time skip confirmation ("Of course" + cancel) is open: the user has
   * left the matching pool but we hold the navigation to written feedback so they can still cancel
   * (re-accept). See `natteringActions.skipConfirm`.
   */
  natteringSkipConfirmActive: boolean;
}
